import { type LinkProps, NavLink } from 'react-router';
import cx from 'clsx';
import styles from './footer-item.module.css';

type FooterItemProps =
  | {
      children: React.ReactNode;
      title?: never;
      afterTitle?: never;
      to?: never;
    }
  | ({
      children?: never;
      title: string;
      afterTitle?: React.ReactNode;
    } & LinkProps);

const getNavLinkClassName = ({ isActive }: { isActive: boolean }) =>
  cx(styles.footerItemLink, isActive && styles.activeFooterItem);

/**
 * Either use `children` for total freedom or use `title`, `afterTitle` and `to` for a link.
 * @public Component to display a footer item.
 */
export function FooterItem({ children, title, afterTitle, to, ...linkProps }: FooterItemProps) {
  return (
    <li className={cx(styles.footerItem, 'overlay')}>
      {to ? (
        <NavLink className={getNavLinkClassName} to={to} {...linkProps}>
          <span className={styles.footerItemLinkTitle}>{title}</span>
          {afterTitle}
        </NavLink>
      ) : (
        children
      )}
    </li>
  );
}
